import { navConfigVar } from "./navConfig";
export var typePolicies = {
    Query: {
        fields: {
            navConfig: {
                read: function () {
                    return navConfigVar();
                },
            },
        },
    },
    Image: {
        keyFields: ["id", "x", "y"],
    },
    Article: {
        keyFields: ["uuid"],
    },
    BasicPage: {
        keyFields: ["uuid"],
    },
    ManualCollection: {
        keyFields: ["uuid"],
    },
    Contest: {
        keyFields: ["uuid"],
    },
    CustomDynamicHero: {
        keyFields: ["uuid"],
    },
    ProgramDynamicHero: {
        keyFields: ["uuid"],
    },
    HomePage: {
        keyFields: ["uuid"],
    },
    Interactive: {
        keyFields: ["uuid"],
    },
    Participate: {
        keyFields: ["uuid"],
    },
    Program: {
        keyFields: ["uuid"],
    },
    Video: {
        keyFields: ["uuid"],
    },
    ProgramOverview: {
        keyFields: ["uuid"],
    },
    Ticket: {
        keyFields: ["uuid"],
    },
};
